import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import flowRight from 'lodash/flowRight'
import { usePrevious } from 'react-nb-hooks'

import { LKModalContainer, LKModalTrigger } from '../shared/LKModal'
import { openConfirmation } from '../shared/LKModal/LKConfirmationModal'

import { DetailsProvider } from './detailsContext'
import Details from './Details'
import container from './container'

const enhance = flowRight(withRouter, container, React.memo)

const DetailsContainerRaw = (props) => {
  const { name, register, unregister, fetchBase } = props

  const dispatch = useDispatch()

  const { type, hash, ID, operationID, operationHash } = props

  const [isUnregistered, setUnregistered] = React.useState(false)

  const handleRefresh = React.useCallback(async () => {
    unregister(type, ID)

    await setUnregistered(true)

    dispatch(openConfirmation(name, undefined))
  }, [dispatch, unregister, name, type, ID])

  const wasUnregistered = usePrevious(isUnregistered)

  React.useEffect(() => {
    fetchBase({ type, ID, hash, operationID, operationHash })
    register(type, ID)

    if (!wasUnregistered && isUnregistered) {
      setUnregistered(false)
    }
    // TODO: needs refactor
    // adding all deps willcouse infinite updates
  }, [type, ID, hash, operationID, operationHash, isUnregistered]) // eslint-disable-line react-hooks/exhaustive-deps

  if (isUnregistered) {
    return null
  }

  return (
    <DetailsProvider
      value={{
        onRefresh: handleRefresh,
      }}
    >
      <Details {...props} />
    </DetailsProvider>
  )
}

DetailsContainerRaw.propTypes = {
  type: PropTypes.string.isRequired,
  hash: PropTypes.string.isRequired,
  tabs: PropTypes.func.isRequired,
  getWindowName: PropTypes.func.isRequired,
  defaultTabId: PropTypes.string.isRequired,
  defaultTabIndex: PropTypes.number,
  baseTabId: PropTypes.string.isRequired,
}

DetailsContainerRaw.defaultProps = {
  defaultTabIndex: 1,
}

const DetailsContainer = enhance(DetailsContainerRaw)

const DetailsContainerModal = LKModalContainer()(DetailsContainer)

export const DetailsModal = ({ disabled, name, icon, children, noTrigger = false, onClose, ...rest }) => (
  <>
    {!noTrigger && (
      <LKModalTrigger disabled={disabled} alias={icon} name={name}>
        {children}
      </LKModalTrigger>
    )}

    <DetailsContainerModal name={name} openContext="modal" onClose={onClose} {...rest} />
  </>
)

export default DetailsContainer
